import React from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
import { Link } from 'react-router-dom';

const SPR = { stiffness: 80, damping: 22, mass: 0.6 };

/**
 * IntroHeader — shown ONLY on the "/" (Home) page.
 * Synced with LogoIntro.jsx scroll:
 *   • Background fades in at 15%–30% of viewport scroll.
 *   • Centered logo fades in at 25%–35% of viewport scroll
 *     (matching the moment the big LogoIntro logo fades out).
 *   • Never transitions to a left logo — stays centered forever.
 */
export default function IntroHeader() {
  const { scrollY } = useScroll();
  const vh = typeof window !== 'undefined' ? window.innerHeight : 800;

  /* Background fade-in */
  const bgOpacityRaw = useTransform(scrollY, [vh * 0.15, vh * 0.3], [0, 1]);
  const bgOpacity = useSpring(bgOpacityRaw, SPR);

  /* Centered logo fade-in — exactly as the big logo fades out */
  const logoOpacityRaw = useTransform(scrollY, [vh * 0.25, vh * 0.35], [0, 1]);
  const logoOpacity = useSpring(logoOpacityRaw, SPR);

  return (
    <header className="fixed top-0 left-0 right-0 z-[10000] pointer-events-none">
      <motion.div
        className="relative w-full h-16 flex items-center justify-center pointer-events-auto"
        style={{
          opacity: bgOpacity,
          background: 'rgba(239,234,225,0.85)',
          backdropFilter: 'blur(32px) saturate(180%)',
          WebkitBackdropFilter: 'blur(32px) saturate(180%)',
          borderBottom: '1px solid rgba(45,42,38,0.1)',
          boxShadow: '0 4px 32px rgba(0,0,0,0.05)',
        }}
      >
        <motion.div style={{ opacity: logoOpacity }}>
          <Link to="/" className="group">
            <motion.img
              src="/iotiq-logo.png"
              alt="IOTIQ"
              className="h-8 md:h-10 object-contain"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Link>
        </motion.div>
      </motion.div>
    </header>
  );
}
